import { Box } from '@mui/material';
import { plPL } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';
import React from 'react';
import { useParameterizedQuery } from 'react-fetching-library';
import toast from 'react-hot-toast';
import { DataGridToolbar } from '../../../components/data-grid/DataGridToolbar';
import Scrollbar from '../../../components/Scrollbar';
import { agreementTemplatesColumns } from '../../../services/column-definitions';
import { downloadAgreementTemplateAction } from '../../../services/request';
import ConfirmDelete from './ConfirmDelete';
import EditAgreementTemplateModal from './EditAgreementTemplateModal';

export default function AgreementTemplateList({ templates, queryCallback, setTemplates }) {
  const [agreementTemplate, setAgreementTemplate] = React.useState({});
  const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
  const [openEditModal, setOpenEditModal] = React.useState(false);
  const { query } = useParameterizedQuery(downloadAgreementTemplateAction);

  const handleDownload = async row => {
    const { payload, error, loading } = await query(row.id);

    if (!error) {
      const url = window.URL.createObjectURL(payload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = `${row.file_name}`;
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      toast.error('Nie udało się pobrać szablonu');
    }

  };

  const handleOpenDeleteModal = row => {
    setAgreementTemplate(row);
    setOpenDeleteModal(true);
  };

  const handleOpenEditModal = row => {
    setAgreementTemplate(row);
    setOpenEditModal(true);
  };

  const searchCallback = search => {
    queryCallback(search);
  };

  return (
    <Scrollbar>
      <Box sx={{ minWidth: { md: 800 }, mt: 4 }}>
        <DataGridPro
          columns={agreementTemplatesColumns(handleDownload, handleOpenDeleteModal, handleOpenEditModal)}
          rows={templates}
          density="standard"
          disableColumnMenu={true}
          autoPageSize={false}
          autoHeight={true}
          rowsPerPageOptions={[10, 25, 50, 100]}
          pagination
          components={{
            Toolbar: DataGridToolbar
          }}
          componentsProps={{ toolbar: { miniView: true, searchCallback } }}
          localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
          disableSelectionOnClick

        />
      </Box>
      {openDeleteModal ? <ConfirmDelete agreementTemplate={agreementTemplate} handleClose={() => setOpenDeleteModal(false)} setTemplates={setTemplates}/> : null}
      {openEditModal ? <EditAgreementTemplateModal agreementTemplate={agreementTemplate} handleClose={() => setOpenEditModal(false)} setTemplates={setTemplates}/> : null}
    </Scrollbar>
  );
};
